// @LTG-ID: data/journals/sell-business-confidentially
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: /app/docs/data-model/journal_content_v1.md, /app/docs/09_CHANGELOG.md#CHG-0108
// @CHANGED: 2026-07-06 (CHG-0108 · Journal port completion, articles 21-40)
// @OWNER: web
//
// Article 29 of 40. Source: batch MD at /app/_ltg_content_batches/batch_3_4/.
// Byline: LTG Team (per CHG-0107.6 §17.3 convention).
// Section: Deal Process (per CHG-0108 D4 orchestrator adjudication).

export const BRIEF = {
    SLUG: "sell-business-confidentially",
    FRONTMATTER: {
        number: "66",
        section: "Deal Process",
        sectionHref: "/journals#deal-process",
        sectionAnchor: "deal-process",
        title: "How to Sell Your Business Confidentially (Without Employees or Competitors Finding Out)",
        deck: "Businesses are sold confidentially through staged disclosure: anonymous blind profiles for initial marketing, nondisclosure agreements and buyer qualification before any identifying details, and employee or customer contact only late in ...",
        author: "LTG Team",
        authorRole: "",
        authorInitials: "LT",
        publishedISO: "2026-06-14",
        publishedHuman: "June 14, 2026",
        lastReviewed: "2026-08-27",
        readMinutes: 3,
        wordCount: 393,
        timeRequired: "PT3M",
        keywords: "how to sell a business confidentially, confidential business sale, keeping a business sale secret, NDA selling a business",
        articleSection: "Deal Process",
        articleBodyPreview: "Businesses are sold confidentially through staged disclosure: anonymous blind profiles for initial marketing, nondisclosure agreements and buyer qualification before any identifying details, and employee or customer contact only late in due diligence. Premature disclosure risks losing staff, customers, and negotiating leverage, so the process is designed to prevent it. A business sale leaks in ways a house sale never could. Employees update resumes, competitors whisper to your customers, supplie",
        complianceNote: "This article is educational and does not constitute legal advice.",
        needsDisclaimerFooter: false,
        internalLinks: [
        "how-long-does-it-take-to-sell-a-business",
        "due-diligence-selling-a-business",
        "do-i-need-a-business-broker"
    ],
        ctaId: "journal-article-primary",
        ctaLabel: "Get Your Valuation",
        pageTitle: "How to Sell Your Business Confidentially · LTG",
        canonical: "https://letstalkgrowth.com/journals/sell-business-confidentially",
        ogImage: "/journals/og/sell-business-confidentially.jpg",
    },
    BODY_MARKDOWN: `Businesses are sold confidentially through staged disclosure: anonymous blind profiles for initial marketing, nondisclosure agreements and buyer qualification before any identifying details, and employee or customer contact only late in due diligence. Premature disclosure risks losing staff, customers, and negotiating leverage, so the process is designed to prevent it.

A business sale leaks in ways a house sale never could. Employees update resumes, competitors whisper to your customers, suppliers tighten terms, and buyers smell urgency. Confidentiality is not paranoia; it is price protection, and the market long ago developed a standard playbook for it.

## The staged-disclosure playbook

**Stage one: the blind profile.** Initial marketing describes the business without identifying it, industry, region, financial ranges, rounded and slightly generalized so that neighbors and competitors cannot solve the puzzle. This is the only version of your business that strangers see.

**Stage two: NDA plus qualification.** Before receiving anything identifying, a prospect signs a nondisclosure agreement and demonstrates they are real: financial capability, relevant background, genuine intent. The qualification step matters as much as the NDA; the most dangerous "buyers" are competitors shopping for intelligence, and screening, which brokers do routinely, is the practical defense, since an NDA deters more than it remedies.

**Stage three: controlled diligence.** Even qualified buyers meet the business in layers. Detailed financials before customer names. Site visits after hours or staged as something routine. Employee and customer contact only near the end, when the deal is real, and even then narrowly.

Throughout, the deal gets an internal code name, documents live in access-controlled data rooms rather than email threads, and meetings happen away from the premises. Small habits, but leaks are almost always small failures.

## The disclosure decisions inside the walls

Sooner or later a small circle must know: typically a bookkeeper or controller who has to produce the documents, and eventually one or two key managers a buyer insists on meeting. The standard practice is to tell each person as late as feasible, under confidentiality, with a direct conversation about their future, often paired with the stay bonuses discussed in our team-depth article. Handled this way, insiders usually become allies; discovered rather than told, they become flight risks. As for the broader team and customers, the announcement belongs after closing, framed jointly with the buyer around continuity, which is, conveniently, exactly what buyers want to communicate too.`,
    FAQ: [
        { question: "Why does confidentiality matter so much when selling a business?", answer: "Premature disclosure can trigger employee departures, customer defections, competitor attacks, and supplier caution, all of which damage the very performance the price is based on. Confidentiality preserves the business's value through the sale process." },
        { question: "Do NDAs actually protect sellers?", answer: "They deter and create legal recourse, but screening matters more: qualifying buyers financially and by background filters out intelligence-gathering competitors before they receive anything sensitive. The NDA is one layer of a staged process, not the whole defense." },
        { question: "When should I tell my employees I am selling?", answer: "Most sellers inform a small circle of essential people late in diligence, individually and under confidentiality, and announce broadly only after closing, together with the buyer and centered on continuity. Early broad disclosure rarely benefits anyone, including the employees." }
    ],
    SOURCES: [
    ],
    END_CTA: {
        label: "READY TO KNOW YOUR NUMBER?",
        headlineLead: "What is your business ",
        headlineEm: "actually",
        headlineTrail: " worth?",
        body: "Indicative valuation signed by Sara. $995 flat.",
        secondaryHref: "/journals",
        secondaryLabel: "More from the Journal \u2192",
        microLine: "\u00b7 7-DAY DELIVERY \u00b7 KGOB METHODOLOGY, NC CPA #30420 \u00b7",
    },
    READ_NEXT: [
        {
            tag: "Exit Planning",
            title: "How Long Does It Take to Sell a Business?",
            meta: "3 min · Brief 43",
            to: "/journals/how-long-does-it-take-to-sell-a-business",
        },
        {
            tag: "Deal Process",
            title: "What Is Due Diligence When Selling a Business? A Seller's Survival Guide",
            meta: "3 min · Brief 56",
            to: "/journals/due-diligence-selling-a-business",
        },
        {
            tag: "Deal Process",
            title: "Do I Need a Business Broker to Sell My Business?",
            meta: "3 min · Brief 67",
            to: "/journals/do-i-need-a-business-broker",
        },
    ],
};

export default BRIEF;
